import Banner from '../components/Dashboard/Banner/Banner.vue'
import BannerDetails from '../components/Dashboard/Banner/BannerDetails.vue';
import Banners from '../components/Dashboard/Banner/Banners.vue';

const bannerRoutes = [
    {
        path: "banner/new",
        component: Banner,
        meta: {
            required: true,
            roles: ["PanelUser"],
        },
        name: "Banner",
    },
    {
        path: "banner/list",
        component: Banners,
        meta: {
            required: true,
            roles: ["PanelUser"],
        },
        name: "Banners",
    },
    {
        path: "banner/list/:id",
        component: BannerDetails,
        meta: {
            required: true,
            roles: ["PanelUser"],
        },
        name: "BannerDetails",
    }
]

export default bannerRoutes;